import { Intent, Position, Tooltip } from "@blueprintjs/core"
import { HTML } from "../interfaces/layouts"

/* Protopia Ecosystem component */
export interface IHintProps {
   position?: Position
   label: HTML | string | JSX.Element
   children: JSX.Element
}
const Hint = (props: IHintProps): JSX.Element => {
    return <Tooltip
        className="flex-no-flex z-index-10000"
        content={ <div className="smaller letter-spacing-2">{ props.label }</div> }
        position={ props.position || Position.TOP_LEFT }
        intent={ Intent.PRIMARY }
        compact
    >
       { props.children }
    </Tooltip>
}
export default Hint